.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.labels {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

.chart-label {
  text-align: right;

  p {
    margin: 0;
  }
}

.chart-label .value {
  font-size: clamp(10px, 1rem + 2vw, 18px);
  line-height: clamp(10px, 1rem + 2vw, 18px);
  color: var(--primary-70);

  span {
    font-size: clamp(8px, 1rem + 2vw, 13px);
  }
}

.chart-label .type {
  font-size: clamp(8px, 1rem + 2vw, 13px);
  line-height: clamp(8px, 1rem + 2vw, 13px);
  font-weight: 400;
  color: #CCC;
}
